import { format } from 'date-fns';
import React from 'react';
import { gql } from '@urql/core';
import { CollegeSendsMessageFragment } from '../../../../generated/spin-graphql';

type Props = {
    message: CollegeSendsMessageFragment;
};

gql`
    fragment CollegeSendsMessage on espin_message {
        contents
        created_at
        college {
            name
        }
    }
`;

export const CollegeSendsMessage: React.FC<Props> = ({ message }) => {
    const author = message.college?.name;
    return (
        <div className="message-container">
            <div className="bubble">{message.contents}</div>
            <div className="message-stamp">
                <span className="author">{author}</span>
                {author && <>{'-'}</>}
                <span className="timestamp">{format(new Date(message.created_at), 'MMM d, y, h:mm a')}</span>
            </div>
        </div>
    );
};
